// extracted by mini-css-extract-plugin
export var compass = "styles-module__compass___gwkYO";
export var brandColor3DButton = "styles-module__brandColor3DButton___KlMWx";